import { render, staticRenderFns } from "./MyFrameDialogComponent.vue?vue&type=template&id=e9a71f50&scoped=true"
import script from "./MyFrameDialogComponent.vue?vue&type=script&lang=js"
export * from "./MyFrameDialogComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e9a71f50",
  null
  
)

export default component.exports